










import { defineComponent } from "@vue/composition-api";

/**
 * 图标按钮
 */
export default defineComponent({
  props: {
    icon: {
      type: String,
      default: "icon-chakanliebiao",
    },
  },
  emits: ["click"],
});
